<section class="container mt-3 mx-auto">
  <div class="alert alert-info container" *ngIf="!faixasCarteira.length; else faixasCarteiraListagem">
    Não foram encontradas faixas de carteira PJ para os filtros especificados.
  </div>
  
  <ng-template #faixasCarteiraListagem>
    <div *ngIf="faixasCarteira && faixasCarteira.length" class="d-flex justify-content-end">
      <button [disabled]="faixasCarteira.length == 0" class="btn btn-secondary m-0" type="button"
        (click)="btnExportarFaixas()" placement="top"
        ngbTooltip="Exporta todas as faixas listadas">
        <i class="fa fa-file"></i> Exportar Faixas</button>
    </div>
    <br>
    <bn-paginacao [total]="atributosPaginacao.count" [(tamanhoPagina)]="atributosPaginacao.pageSize"
      [(numPagina)]="atributosPaginacao.page" [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">
    
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th scope="col">Agente Financeiro</th>
              <th scope="col">CNPJ Agente</th>
              <th scope="col">Faixa</th>
              <th scope="col">Data Início</th>
              <th scope="col">Data Fim</th>
              <th scope="col">Peso Conglomerado</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of faixasCarteira">
              <td>{{item.razaoSocial}}</td>
              <td>{{item.cnpjAgenteFinanceiro}}</td>
              <td>{{item.valorFaixa.labelFaixa}}</td>
              <td>{{item.dataInicioValidade | date: 'dd/MM/yyyy'}}</td>
              <td>{{item.dataFimValidade | date: 'dd/MM/yyyy'}}</td>
              <td class="text-center">{{formatarPontoVirgula(item.pesoConglomerado)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </bn-paginacao>
  </ng-template>

</section>